export const DISPLAYED_HOUR_ON_X_AXIS = 6
export const Y_AXIS_CLASS = '.y.axis'
export const TEXT_ANCHOR_START = 'start'
export const TEXT_ANCHOR_MIDDLE = 'middle'
export const TEXT_ANCHOR_ATTR = 'text-anchor'
export const ARIA_HIDDEN = true
export const ARIA_HIDDEN_STRING = 'aria-hidden'

export const RANGE_BUFFER_DIVISOR = 3
export const MIN_RANGE_VALUE = 1
export const TIME_RANGE_PADDING = 0.05
export const Y_AXIS_NICE_TICKS = 5

export const TICK_OFFSET_X1 = -5
export const TICK_TEXT_OFFSET_X = 9
export const TICK_OVERLAP_MARGIN = 5

export const TIME_LABEL_OFFSET_Y = 9
export const TIME_LABEL_OFFSET_X_MOBILE = -20
export const TIME_LABEL_OFFSET_X_DESKTOP = -24
export const TIME_NOW_TSPAN_DY = '15'

export const TOOLTIP_TEXT_HEIGHT_OFFSET = 23
export const TOOLTIP_PATH_LENGTH = 140
export const TOOLTIP_PATH_LENGTH_WIDE = 175
export const TOOLTIP_MARGIN_TOP = 10
export const TOOLTIP_MARGIN_BOTTOM_OFFSET = 10
export const TOOLTIP_VERTICAL_OFFSET = 40
export const TOOLTIP_TEXT_X_OFFSET = 12
export const TSPAN_DY_OFFSET_LARGE = '1.4em'
export const THIRTY_DAYS = 30
export const LOCATOR_CIRCLE_RADIUS = 5
export const DEFAULT_TOOLTIP_Y = 10

export const MARGIN_TOP = 20
export const MARGIN_BOTTOM = 45
export const MARGIN_LEFT = 15
export const MOBILE_MARGIN_RIGHT_BASE = 15
export const DESKTOP_MARGIN_RIGHT_BASE = 36
export const MARGIN_CHAR_MULTIPLIER = 9
export const MOBILE_BREAKPOINT = '(max-width: 640px)'

export const TOLERANCE_TIDE = 10000000
export const TOLERANCE_DEFAULT = 1000000
export const DECIMAL_PLACES = 2
export const DEFAULT_WIDTH = 800
export const DEFAULT_HEIGHT = 400

export const SEVEN_DAYS = 7
export const FORECAST_POINTS_RATIO = 0.3
